// extracted by mini-css-extract-plugin
export default {"container":"style_container__1v8zu","titleSection":"style_titleSection__toSsm"};